import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import { productShippingDefaultsSavedSubject } from '../../store/products/products.epic';
import { useFulfillmentPlannerContext } from '../context';
import { useSaveProductShippingData } from '../../hooks/use-save-product-shipping-data';

import messages from './messages';
import style from './style.module.css';

const CSWShippingDefaultsButton = () => {
  const { fulfillmentPlanId, isRating } = useFulfillmentPlannerContext();
  const { asyncSaveShippingDefaults, cswProductId, isSingleOrder } = useSaveProductShippingData(fulfillmentPlanId);
  const [buttonText, setButtonText] = useAsyncSafeState(messages.clickToSave);

  useEffect(() => {
    const subscription = productShippingDefaultsSavedSubject.subscribe(({ didSaveDefaults }) => {
      if (didSaveDefaults) {
        setButtonText(messages.saveSuccessful);
      }
    });

    setButtonText(messages.clickToSave);
    return () => subscription.unsubscribe();
  }, [isRating, setButtonText]);

  const shouldBeDisabled = isRating || buttonText === messages.saveSuccessful;
  return (
    <div className={style['shipping-default-wrapper']}>
      {isSingleOrder && cswProductId && (
        <Button disabled={shouldBeDisabled} onClick={asyncSaveShippingDefaults} theme='link'>
          <FormattedMessage {...buttonText} />
        </Button>
      )}
    </div>
  );
};

export default CSWShippingDefaultsButton;
